














import Vue from 'vue';
import { OpenViewAccountNumberScreen } from '@/mixins/get-content-mixins';

import SettingWrapper from '../setting-wrapper.component.vue';

import { TokenReAuth } from '@/components/page-components';
import { ExtendMixins } from '@/services';
import { MemberPersonalInformationResponseModel } from '@/@types/member';

interface Data {
  tokenModal: boolean;
}

export default ExtendMixins(
  OpenViewAccountNumberScreen,
).extend({
  name: 'ViewAccountNumber',
  props: {
    accountNumber: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      tokenModal: false,
    };
  },
  computed: {
    accountNumberCTA(): string {
      return this.$options.filters.t('global_view');
    },
    personalInformation(): MemberPersonalInformationResponseModel {
      return this.$store.getters.personalInformation;
    },
  },
  methods: {
    viewAccountNumber(): void {
      this.openViewAccountNumberScreen({ accountNumber: this.accountNumber });
    },
    openTokenModal(): void {
      this.tokenModal = true;
    },
  },
  components: {
    SettingWrapper,
    TokenReAuth,
  },
});
